module.exports = __webpack_public_path__ + "static/media/more-select-premium.12229d9f.svg";